import { langPath, type Lang } from "@/lib/i18n";
import type { ModuleRefTypeEnum } from "@/lib/lecturehub/types";

/** Slug-keyed like posts and FAQs (`collection(slug)` is the only read);
 *  `library` builds the signed-in twin. */
export function collectionHref(lang: Lang, slug: string | null | undefined, library = false) {
  return langPath(
    lang,
    `${library ? "/library" : ""}/collections/${encodeURIComponent(slug ?? "")}`,
  );
}

export function collectionsIndexHref(lang: Lang, library = false) {
  return langPath(lang, library ? "/library/collections" : "/collections");
}

/** "See all" for one block of a topic, or for the hand-picked extras. */
export function collectionAllHref(
  lang: Lang,
  slug: string | null | undefined,
  library: boolean,
  of: { topicId: string; type: ModuleRefTypeEnum } | { extras: true; type: ModuleRefTypeEnum },
) {
  const q =
    "extras" in of
      ? `extras=1&type=${of.type}`
      : `topic=${encodeURIComponent(of.topicId)}&type=${of.type}`;
  return `${collectionHref(lang, slug, library)}/all?${q}`;
}
